import { DATABASE_VIEW } from '@confluence/named-routes/entry-points/routes';
import { CONTEXT_PATH } from '@confluence/named-routes/entry-points/context';

export type NavigateToObjectParams = {
	baseUrl: string;
	path: string;
};

export const isSpaTransition = (baseUrl: string): boolean => {
	const host = window.location.host;
	return baseUrl.includes(host) && baseUrl.includes(CONTEXT_PATH);
};

// database need flow query param for special case handling
const addFlowParam = (baseUrl: string, path: string): string => {
	const url = new URL(path, baseUrl);
	url.searchParams.set('flow', 'aiCreate');
	return url.pathname + url.search;
};

type PushFunction = (path: string) => void;
export const createNavigateToObject =
	(push: PushFunction) =>
	({ baseUrl, path }: NavigateToObjectParams) => {
		const isDatabase = Boolean(DATABASE_VIEW.match(`${baseUrl}${path}`));
		let finalPath = path;
		if (isDatabase) {
			finalPath = addFlowParam(baseUrl, path);
		}

		if (isSpaTransition(baseUrl)) {
			push(CONTEXT_PATH + finalPath);
		} else {
			window.location.href = `${baseUrl}${finalPath}`;
		}
	};
